import React, { useEffect, useState, useRef } from 'react';
import { Button, TextField } from "@material-ui/core";
import FaqRealtor from './FaqRealtor';
import { useFormik } from 'formik';
import '../../styles/content.scss';
import config from '../config/config';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { Link } from "react-scroll";
import Modalpopup from '../pages/Modalpopup/Modalpopup';
import CustomDrawer from '../common/CustomDrawer/CustomDrawer';
import moment from 'moment';
import Modalpopupcalquemarket from '../landing/Modalpopups/Modalpopupcalquemarket';
import GoogleMapsGet from '../common/GoogleMap/GoogleMapsGet';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InstagramIcon from '@material-ui/icons/Instagram';
import YouTubeIcon from '@material-ui/icons/YouTube';
import BannerRealtor from './BannerRealtor';
import HowitWorksRealtor from './HowitWorksRealtor';
import WhyChooseRealtor from './WhyChooseRealtor';
import AboutRealtor from './AboutRealtor';
import { useGAEventsTracker } from '../../util/gtag';
import ApplicationFunnel from '../common/ApplicationFunnelWidget/ApplicationFunnel';

let addr = null
export default function ContentRealtor(props) {
    /** google analytics event category */
    const GAEventTracker = useGAEventsTracker(window.location.pathname)
    const GAEventTrackerGetStarted = useGAEventsTracker(window.location.pathname + "/Get Started");
    const GAEventTrackerQuesttionaire = useGAEventsTracker(window.location.pathname + "/Questionnaire")
    const GAEventTrackerContactUs = useGAEventsTracker(window.location.pathname + "/Contact Us");
    const GAEventTrackerFooterLinkedIn = useGAEventsTracker(window.location.pathname + "/Linked In")
    const GAEventTrackerFacebook = useGAEventsTracker(window.location.pathname + "/Facebook")
    const GAEventTrackerInstagram = useGAEventsTracker(window.location.pathname + "/Instagram")
    const GAEventTrackerYouTube = useGAEventsTracker(window.location.pathname + "/You Tube")
    const GAEventTrackerTermsOfUse = useGAEventsTracker(window.location.pathname + "/Calque Terms Of Use")
    const GAEventTrackerPrivacyPolicy = useGAEventsTracker(window.location.pathname + "/Calque Privacy Policy")
    const GAEventTrackerSection = useGAEventsTracker(window.location.pathname + "/Section")
    const [pageNumber,setPageNumber] = useState(1);
    const [showNxtButton,setShowNxtButton] = useState(false);
    const [efficient, setEfficient] = React.useState(false)
    const [openSubmit, setOpenSubmit] = React.useState(false);
    const [openFailure, setOpenFailure] = useState(false)
    const [captch_visible, setCaptchaVisible] = useState(true)
    const [errorMessage, setErrorMessage] = useState()
    const [loaderNext, setLoaderNext] = useState(false)
    const [openSuccess, setOpenSuccess] = useState(false)
    const [drawerClose, setDrawerClose] = useState(true)
    const [emailEditErr, setEmailEditErr] = useState(false)
    const [validateDisplay, setValidateDisplay] = useState(false)
    const [validateDisplay0, setValidateDisplay0] = useState(false)
    const [validateDisplay1, setValidateDisplay1] = useState(false)
    const [validateDisplay2, setValidateDisplay2] = useState(false)
    const [validateDisplay3, setValidateDisplay3] = useState(false)
    const [validateDisplay4, setValidateDisplay4] = useState(false)
    const [validateDisplay5, setValidateDisplay5] = useState(false)
    const [validateDisplay6, setValidateDisplay6] = useState(false)
    const [validateDisplay7, setValidateDisplay7] = useState(false)
    const [validateDisplay8, setValidateDisplay8] = useState(false)
    const [validateDisplay9, setValidateDisplay9] = useState(false)
    const [validateDisplay10, setValidateDisplay10] = useState(false)
    const [validateDisplay11, setValidateDisplay11] = useState(false)
    const [validateDisplay16, setValidateDisplay16] = useState(false)
    const [validateDisplay17, setValidateDisplay17] = useState("")
    const [validateDisplay18, setValidateDisplay18] = useState("")
    const [questionGA1Capture, setQuestionGA1Capture] = useState(false)
    const [questionGA2Capture, setQuestionGA2Capture] = useState(false)
    const [questionGA3Capture, setQuestionGA3Capture] = useState(false)
    const [questionGA5Capture, setQuestionGA5Capture] = useState(false)
    const [questionGA6Capture, setQuestionGA6Capture] = useState(false)
    const [questionGA7Capture, setQuestionGA7Capture] = useState(false)
    const [questionGA8Capture, setQuestionGA8Capture] = useState(false)
    const [questionGA9Capture, setQuestionGA9Capture] = useState(false)
    const [questionGA10Capture, setQuestionGA10Capture] = useState(false)
    const [questionGA11Capture, setQuestionGA11Capture] = useState(false)
    const [questionGA12Capture, setQuestionGA12Capture] = useState(false)
    const [questionGA13Capture, setQuestionGA13Capture] = useState(false)
    const [questionGA14Capture, setQuestionGA14Capture] = useState(false)
    const [questionGA15Capture, setQuestionGA15Capture] = useState(false)
    const [questionGA16Capture, setQuestionGA16Capture] = useState(false)
    const [questionGA17Capture, setQuestionGA17Capture] = useState(false)
    const [questionGA18Capture, setQuestionGA18Capture] = useState(false)
    const [questionGA19Capture, setQuestionGA19Capture] = useState(false)
    const [questionGA20Capture, setQuestionGA20Capture] = useState(false)
    const [sectionEligibilityGA, setSectionEligibityGA] = useState(false)
    const [sectionHomeFactsGA, setSectionHomeFactsGA] = useState(false)
    const [sectionPreferenceGA, setSectionPreferenceGA] = useState(false)
    const [sectionEligibilityGAPartial, setSectionEligibityGAPartial] = useState(false)
    const [sectionHomeFactsGAPartial, setSectionHomeFactsGAPartial] = useState(false)
    const [sectionPreferenceGAPartial, setSectionPreferenceGAPartial] = useState(false)
    const [emailEdit, setEmailEdit] = React.useState(false);
    const [emailValue, setEmailValue] = React.useState("")
    const [emailError, setEmailError] = useState(false)
    const [cdrawer, setCDrawer] = useState(false)
    const [cdrawerHome, setCDrawerHome] = useState(false)
    const [loader, setLoader] = useState(false)
    const [emailOneDisable, setEmailOneDisable] = useState(false)
    const [errDisplay, setErrDisplay] = useState(false);
    const [openCalque, setOpenCalque] = useState(false);
    const [zipcodeExists, setZipCodeExists] = useState(false);
    const [zipcodeEmptyErr, setZipcodeEmptyErr] = useState(false);
    const [popError, setPopErr] = useState([]);
    const [validateControl, setValidateControl] = useState(false)
    const [submitSuccess, setSubmitSuccess] = useState(false)
    const [submitValidationSuccess, setSubmitValidationSuccess] = useState(false)
    const [displayError, setDisplayError] = useState(false)
    const [gaUserNotAnswered, setGaUserNotAnswered] = useState(false)
    const [old_address, setOldAddress] = useState('');
    const [old_property_type_id, setOldPropertyID] = useState(null);
    const [propertyID, setPropertyID] = useState(null);
    const [resetPadding, setResetPadding] = useState('')
    const [captchaValue, setCaptchaValue] = useState(null);
    const [isSelectedLo, setIsSelectedLo] = useState(false);
    const [isSelectedAgent, setIsSelectedAgent] = useState(false);

    useEffect(() => {
        const pathName = window.location.pathname; // Get current pathname
        if (pathName.includes("questionnaire")) {
          setCDrawerHome(true); // Set to true if the page includes "questionnaire"
        }
    
        // Prevent back button navigation on questionnaire page
        window.history.pushState(null, null, window.location.href);
        window.onpopstate = function (event) {
          window.history.go(1); // Stay on the current page if the user hits the back button
        };
    }, []);

    const handleClickOpen2 = () => {
        setOpenSubmit(!openSubmit);
    };
    const handleCloseSuccess = () => {
        window.location.reload()
    }
    const handleCloseFailure = () => {
        window.location.reload()
    }
    const handleEfficient = (e) => {
        setEfficient(true)
    }
    const handlePopUpClose1 = () => {
        setOpenFailure(!openFailure)
        window.location.reload()
    }
    const handlePopUpClose = () => {
        setOpenSuccess(!openSuccess);
        if (window.location.pathname.includes("questionnaire")) {
          // Correctly remove '/questionnaire' from the current URL
          const newPath = window.location.pathname.replace("/questionnaire", "");
          // Update the URL without reloading the page
          window.history.pushState({}, "", `${window.location.origin}${newPath}`);
        }
        setCDrawer(false);
        window.location.reload();
    };
    const [displayPropertyLoc, setDisplayPropertyLoc] = useState(false)
    const handleClose1 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };
    const vertical = 'top';
    const horizontal = 'center';
    const [detail, setDetail] = React.useState('');
    const [severity_type, setSeverityType] = React.useState('');
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const handleScrollOpen = () => {
        if (formik.values.property_address.street_address !== "" && formik.values.property_type_id !== null && formik.values.property_address.zip_code !== null) {
            setDisplayPropertyLoc(true)
            setCDrawer(true)
            setCDrawerHome(false)
            document.body.style.position = 'unset'
            let root = document.getElementById('root')
            root.style.position = "fixed"
        }
    }
    const handleScrollOpenHome = () => {
        setDisplayPropertyLoc(true)
        setCDrawerHome(true)
        setCDrawer(false)
        document.body.style.position = 'unset'
        let root = document.getElementById('root')
        root.style.position = "fixed"
    }
    const handleScrollClose = () => {
        setDisplayPropertyLoc(false)
        setCDrawer(false)
        setCDrawerHome(false)
        document.body.style.position = 'unset'
        let root = document.getElementById('root')
        root.style.position = "unset"
    }
    const initialValues = {
        is_owner: "",
        is_primary_residence: "",
        property_in_sqft: null,
        view_from_property: [],
        property_flooring_id: [],
        next_to_property: [],
        estimate_appraised: '',
        home_worth: '',
        new_home_purchase_price: null,
        is_equity_required: '',
        equity_unlock_requested : null,
        appraised_value: null,
        other_fees_comment: null,
        fees_amount: null,
        property_major_improvement_confirm: null,
        property_major_improvements_id: [],
        property_applies_id: [],
        property_overall_condition_id: null,
        hear_about_us_option_id: null,
        how_did_you_hear_about_us_description: "",
        home_view_id: [],
        is_any_defects:"",
        property_defect_id:[],
        alteration_1:"",
        alteration_2:"",
        any_settling:"",
        flooding:"",
        major_damage:"",
        condo_unit_number:"",
        condo_association_name:"",
        property_kitchen_appliances_color_id: null,
        property_kitchen_countertops_id: null,
        property_required_replaces_id: [],
        ready_to_sell: null,
        property_type_id: null,
        bedrooms: 0,
        full_bathrooms: 0,
        partial_bathrooms: 0,
        other_bedrooms: 0,
        non_owner_comments: "",
        property_build_year: "",
        property_purchase_year: null,
        garage_type: false,
        property_ready_to_sell_id: null,
        monthly_dues: null,
        planning_to_buy_new_home: "",
        property_reason_for_sale_id: null,
        customer_info: {
            customer_first_name: "",
            customer_last_name: "",
            customer_email: "",
            customer_email_last: "",
            customer_phone_no: ""
        },
        property_address: {
            street_address: "",
            city: "",
            state: "",
            zip_code: null,
            county: "",
            state_code: null
        },
        property_address_get: {
            street_address: "",
            city: "",
            state: "",
            zip_code: null,
            county: "",
            state_code: null
        },
        property_special_feature_id: [],
        garage_parking_count: 0,
        price_paid: '',
        estimate: '',
        total_mortgage: null,
        total_mortgage_amount: null,
        finance_not_sure: null,
        estimate_not_sure: null,
        other_fees: null,
        purchased_date: null,
        estimate_date: null,
        property_not_sure: null,
        other_features: null,
        about_house_not_sure: '',
        property_id: null,
        first_name: '',
        last_name: '',
        email: '',
        "location": '',
        is_loan_officer: '',
        loan_officer: null,
        loan_officer_info: {
            first_name: '',
            last_name: '',
            email: '',
            phone_number: ''
        },
        is_real_estate_agent: '',
        real_estate_agent: null,
        real_estate_agent_info: {
            first_name: '',
            last_name: '',
            email: '',
            phone_number: ''
        }
    }
    const [progress, setProgress] = useState(0)
    const onSubmit = values => {
        var postData = {
            property_address: {
                street_address: values.property_address.street_address ? values.property_address.street_address.split(",")[0] : values.property_address_get.street_address.split(",")[0],
                city: values.property_address.city ? values.property_address.city : values.property_address_get.city,
                state: values.property_address.state ? values.property_address.state : values.property_address_get.state,
                zip_code: values.property_address.zip_code ? values.property_address.zip_code : values.property_address_get.zip_code,
                county: values.property_address.county ? values.property_address.county : values.property_address_get.county,
                state_code: values.property_address.state_code ? values.property_address.state_code : values.property_address_get.state_code
            },
            property_type: values.property_type_id ? Number(values.property_type_id) : null,
            is_owner: values.is_owner === "yes" ? true : false,
            is_primary_residence: values.is_primary_residence === "yes" ? true : false,
            non_resident_comments: values.non_resident_comments === '' ? '' : values.non_resident_comments,
            alterations_and_problems:{
                "Room additions, structural modifications, or other alterations or repairs made without necessary permits":values.alteration_1 === "yes" ? true : values.alteration_1 === "no" ? false : null,
                "Room additions, structural modifications, or other alterations or repairs not in compliance with building codes":values.alteration_2 === "yes" ? true : values.alteration_2 === "no" ?false : null,
                "Any settling from any cause, or slippage, sliding, or other soil problems":values.any_settling === "yes" ? true : values.any_settling === "no" ? false : null,
                "Flooding, drainage or grading problems":values.flooding === "yes" ? true : values.flooding === "no" ? false : null,
                "Major damage to the property or any of the structures from fire, earthquake, floods, or landslides":values.major_damage === "yes" ? true : values.major_damage === "no" ? false : null,
            },
            non_owner_comments: values.non_owner_comments === '' ? '' : values.non_owner_comments,
            customer_info: {
                customer_email: values.customer_info.customer_email === emailValue || emailValue === "" ? values.customer_info.customer_email : emailValue,
                customer_phone_no: values.customer_info.customer_phone_no,
                customer_first_name: values.customer_info.customer_first_name,
                customer_last_name: values.customer_info.customer_last_name,
            },
            purchase_and_finance_history: {
                purchase_date: values.purchased_date === null ? null : moment(values.purchased_date).format('YYYY-MM-DD'),
                purchase_price: values.price_paid === null ? null : parseFloat(values.price_paid.replace(/[$,]/g, '')),
                total_mortgage_amount: values.total_mortgage === null ? null : parseFloat(values.total_mortgage.replace(/[$,]/g, '')),
                is_mortgage_amount: values.estimate === "yes" ? true : false,
                monthly_mortgage_amount: values.total_mortgage_amount === null ? null : parseFloat(values.total_mortgage_amount.replace(/[$,]/g, '')),
                home_value: values.home_worth === null ? null : parseFloat(values.home_worth.replace(/[$,]/g, '')),
            },
            new_home_purchase_price: values.new_home_purchase_price === null ? null : parseFloat(values.new_home_purchase_price.replace(/[$,]/g, '')),
            is_equity_required: values.is_equity_required === "true" ? true : false,
            equity_unlock_requested: values.equity_unlock_requested === null ? null : parseFloat(values.equity_unlock_requested.replace(/[$,]/g, '')),
            fees_are_for: values.other_fees_comment === null ? null : values.other_fees_comment,
            monthly_dues: values.fees_amount === null ? null : parseFloat(values.fees_amount.replace(/[$,]/g, '')),
            property_overall_condition: (values.property_overall_condition_id === null || values.property_overall_condition_id === "") ? null : Number(values.property_overall_condition_id),
            property_details: {
                house_built_year: values.property_build_year === "" ? null : Number(values.property_build_year),
                property_in_sqft: values.property_in_sqft === (null || "") ? null : Number(values.property_in_sqft),
            },
            defects: values.property_defect_id.length > 0 ? values.property_defect_id.map((items) => Number(items)) : null,
            ready_for_selling: values.property_ready_to_sell_id === null ? null : Number(values.property_ready_to_sell_id),
            reason_for_sale: values.property_reason_for_sale_id === null ? null : Number(values.property_reason_for_sale_id),
            partner: props.partner.partner_id ? props.partner.partner_id : null,
            is_loan_officer: values.is_loan_officer === "" ? false : (values.is_loan_officer === "true" ? true : false),
            loan_officer_info: {
                first_name: values.loan_officer_info.first_name,
                last_name: values.loan_officer_info.last_name,
                email: values.loan_officer_info.email === undefined ? '' : values.loan_officer_info.email,
                phone_number: (values.loan_officer_info.phone_number === undefined || values.loan_officer_info.phone_number === null || values.loan_officer_info.phone_number === '') ? null : values.loan_officer_info.phone_number
            },
            is_real_estate_agent: values.is_real_estate_agent === '' ? false : (values.is_real_estate_agent === "true" ? true : false),
            real_estate_agent_info: {
                first_name: values.real_estate_agent_info.first_name,
                last_name: values.real_estate_agent_info.last_name,
                email: values.real_estate_agent_info.email === undefined ? '' : values.real_estate_agent_info.email,
                phone_number: (values.real_estate_agent_info.phone_number === undefined || values.real_estate_agent_info.phone_number === null || values.real_estate_agent_info.phone_number === '') ? null : values.real_estate_agent_info.phone_number
            },
            hear_about_us_option_id: values.hear_about_us_option_id === null ? null : parseInt(values.hear_about_us_option_id),
            how_did_you_hear_about_us_description: values.how_did_you_hear_about_us_description === "" ? "" : values.how_did_you_hear_about_us_description,
            condo_unit_number: values.condo_unit_number === (null || "") ? "" : values.condo_unit_number.trim(),
            condo_association_name: values.condo_association_name === (null || "") ? "" : values.condo_association_name.trim(),
        };
        setLoader(true)
        let authorise = process.env.REACT_APP_API_KEY
        fetch(`${config.baseUrlCP}property/${values.property_id}/`,
            {
                method: 'PATCH',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `${authorise}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(postData),
            })
            .then(async response => {
                const results = await response.json()
                if (response.status === 201 || response.status === 200) {
                    GAEventTrackerQuesttionaire("UserAnsweredTillFinish", 1)
                    props.GAtimerFinish()
                    setDetail(results.message);
                    setSeverityType("success");
                    setOpenSuccess(!openSuccess);
                    setDrawerClose(false)
                    await sleep(2000);
                    setLoader(false)
                }
                else {
                    setLoader(false)
                    if (results.detail) {
                        setDetail(results.detail)
                        setSeverityType("error");
                        setOpenFailure(!openFailure);
                        setDrawerClose(false)
                        await sleep(2000);
                    } else {
                        setSeverityType("error");
                    }
                }
            })
            .catch((error) => {
            })
    }
    const validatePopUp = () => {
        let errors = {};
        if (formik.values.first_name === '') {
            errors.first_name = "Please enter first name"
        }
        if (formik.values.last_name === '') {
            errors.last_name = "Please enter last name"
        }
        if (formik.values.email === '') {
            errors.email = "Please provide a valid Email Address"
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formik.values.email)) {
            errors.email = 'Please provide a valid Email Address';
        }
        setPopErr(errors)
        return errors;
    }
    const validate = values => {
        let errors = {};
        if (!values.property_address_get.street_address) {
            if (!values.property_address.street_address || values.property_address.street_address === '') {
                errors.street_address = "Address Entered is not valid, Please enter a valid USA address"
            } else if (values.property_address.zip_code === null) {
                errors.street_address = "Address Entered is not valid, Please enter a valid USA address"
            }
        }
        if (!values.property_address.street_address) {
            if (!values.property_address_get.street_address || values.property_address_get.street_address === '') {
                errors.street_address = "Address Entered is not valid, Please enter a valid USA address"
            } else if (values.property_address_get.zip_code === null) {
                errors.street_address = "Address Entered is not valid, Please enter a valid USA address"
            }
        }
        if (!values.property_type_id) {
            errors.property_type_id = "Please select the property type"
        }
        if (values.is_owner.trim() === "") {
            errors.non_owner_comments = "Please select the appropriate answer."
        } else if (values.is_owner === "yes" && (values.is_primary_residence !== "yes" && values.is_primary_residence !== "no")) {
            errors.non_owner_comments = "Please select the appropriate answer."
        } else if (values.is_owner === "no" && (!values.non_owner_comments || values.non_owner_comments.trim() === "")) {
            errors.non_owner_comments = "Please enter the clarification."
        }
        if (!values.customer_info.customer_first_name) {
            errors.customer_email = "Please provide your First Name."
        } else if (!values.customer_info.customer_last_name) {
            errors.customer_email = "Please provide your Last Name."
        }else if (!values.customer_info.customer_phone_no || values.customer_info.customer_phone_no === "") {
            errors.customer_email = "Please provide Phone Number."
        }
        if (!values.customer_info.customer_email) {
            errors.customer_email = "Please provide a valid Email Address."
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.customer_info.customer_email)) {
            errors.customer_email = 'Please provide a valid Email Address.';
        }
        if ((values.price_paid === '' || values.home_worth === '') || (values.price_paid === '$' || values.home_worth === '$') || (values.estimate === "")) {
            errors.finance_history = "Please enter the purchase price, home worth and select total mortgage amount.";
        } else if ((values.estimate === "yes" && !(values.total_mortgage || values.total_mortgage_amount) || (values.total_mortgage === '$' && values.total_mortgage_amount === '$'))) {
            errors.finance_history = "Please enter total mortgage amount or monthly mortagage payment amount."
        }
        if (!values.other_fees) {
            errors.monthly_dues = "Please select the appropriate answer."
        } else if ((values.other_fees === "yes" && !values.fees_amount) || (values.other_fees === "yes" && values.fees_amount === "$")) {
            errors.monthly_dues = "Please provide the amount."
        }
        if (!values.hear_about_us_option_id) {
            errors.hear_about_us_option_id = "Please select the appropriate answer."
        }
        if (!values.new_home_purchase_price || values.new_home_purchase_price === "$") {
            errors.new_home_purchase_price = "Please provide the maximum price for new home."
        }
        if (!values.is_equity_required) {
            errors.equity_unlock_requested = "Please select the appropriate answer."
        } else if (values.is_equity_required === "true" && !values.equity_unlock_requested) {
            errors.equity_unlock_requested = "Please provide the amount."
        }
        if (values.is_loan_officer === "") {
            errors.loan_officer = "Please select the appropriate answer."
        } else if (((values.is_loan_officer === 'true') && (values.loan_officer === null || values.loan_officer === "") && (values.loan_officer_info.first_name === "" || values.loan_officer_info.last_name === ""))) {
            errors.loan_officer = "Please fill the mandatory(*) fields."
        } else if (values.loan_officer_info.email !== "" && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.loan_officer_info?.email)){
            errors.loan_officer = 'Please provide a valid Email Address.';
        }
        if (values.is_real_estate_agent === "") {
            errors.real_estate_agent = "Please select the appropriate answer."
        } else if (((values.is_real_estate_agent === 'true') &&(values.real_estate_agent === null || values.real_estate_agent === "") && (values.real_estate_agent_info.first_name === "" || values.real_estate_agent_info.last_name === ""))) {
            errors.real_estate_agent = "Please fill the mandatory(*) fields."
        }else if (values.real_estate_agent_info.email !== "" && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.real_estate_agent_info?.email)){
            errors.real_estate_agent = 'Please provide a valid Email Address.';
        }
        if(sessionStorage.getItem('property_type_id') !== 'none' && sessionStorage.getItem('property_type_id') !== formik.values.property_type_id && sessionStorage.getItem('captcha_val') !== sessionStorage.getItem('captchaFreshValue') || sessionStorage.getItem('address') !== 'none' && sessionStorage.getItem('address') !== formik.values.property_address.street_address.split(",")[0] && sessionStorage.getItem('captcha_val') !== sessionStorage.getItem('captchaFreshValue')) {
            if(captchaValue === false) {
                setCaptchaValue(null)
            } else {
                setCaptchaValue(false)
            }
        } else if (captchaValue === false || captchaValue === null) {
            setCaptchaValue(false)
        } else {
            setCaptchaValue(true)
        }
        if (captchaValue === false || captchaValue === null && sessionStorage.getItem('captcha_val') === '') {
            errors.captcha_error_msg = 'Please provide value'
        }

        return errors;
    }
    const formik = useFormik({
        initialValues,
        onSubmit,
        validate,
    });
    const myRef = useRef([]);
    const handleProgress = (e) => {
        let tempProgress = 0

        if (!formik.errors.street_address) {
            tempProgress += 0
            setProgress(0)
        }
        if ((formik.values.is_owner === "yes" && formik.values.is_primary_residence) || (formik.values.is_owner === "no" && formik.values.non_owner_comments !== "")) {
            tempProgress += 5.88
        }
        if (!formik.errors.customer_email) {
            tempProgress += 5.88
        }
        if (!formik.errors.finance_history) {
            tempProgress += 5.88
        }
        if (!formik.errors.home_appraisal) {
            tempProgress += 5.88
        }
        if (!formik.errors.monthly_dues) {
            tempProgress += 5.88
        }
        // if (!formik.errors.property_overall_condition) {
        //     tempProgress += 6.68
        // }
        if (!formik.errors.new_home_purchase_price && formik.values.new_home_purchase_price !== "$") {
            tempProgress += 5.88
        }
        if (formik.values.is_equity_required === "false" || (formik.values.is_equity_required === "true" && formik.values.equity_unlock_requested !== '')) {
            tempProgress += 5.88
        } 
        if (!formik.errors.loan_officer) {
            tempProgress += 5.88
        }
        if ((formik.values.is_real_estate_agent === 'true' && (!formik.values.real_estate_agent_first_name || !formik.values.real_estate_agent_last_name || !formik.values.real_estate_agent_email)) || formik.values.is_real_estate_agent === 'false') {
            tempProgress += 5.88
        } else {
            tempProgress += 0
        }
        if (!formik.errors.hear_about_us_option_id) {
            tempProgress += 5.88
        }
        if ((formik.values.condo_unit_number || formik.values.condo_association_name || formik.values.property_build_year && formik.values.property_in_sqft) || formik.values.property_not_sure) {
            tempProgress += 6.68
        }
        if (formik.values.septic === "yes" || formik.values.septic === "no") {
            tempProgress += 6.68
        }
        if (formik.values.property_overall_condition_id !== null && formik.values.property_overall_condition_id !== "") {
            tempProgress += 6.68
        }
        if (formik.values.property_defect_id.length > 0 ) {
            tempProgress += 6.68
        }
        if (formik.values.alteration_1 !== "" || formik.values.alteration_2 !== "" || formik.values.any_settling !== "" || formik.values.flooding !== "" || formik.values.major_damage !== "") {
            tempProgress += 6.68
        }
        if (formik.values.property_ready_to_sell_id !== null) {
            tempProgress += 6.68
        }
        if (formik.values.property_reason_for_sale_id !== null) {
            tempProgress += 6.68
        }
        setProgress(tempProgress)
    }
    const handleNext = (e) => {
        let ele;
        if (e === "owner" && (!formik.errors.street_address)) {
            ele = document.getElementById("verify")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)

            }
        }

        if (e === "verify" && (!formik.errors.non_owner_comments)) {
            ele = document.getElementById("moreinfo")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "moreinfo" && (!formik.errors.customer_email)) {
            ele = document.getElementById("financehistory")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "financehistory" && (!formik.errors.finance_history)) {
            ele = document.getElementById("association")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "association" && (!formik.errors.monthly_dues)) {
            ele = document.getElementById("condition")
            if (ele) {
                let captcha = document.getElementById("recaptcha2")
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "condition" && (!formik.errors.property_overall_condition)) {
            ele = document.getElementById("newhome")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "newhome" && (!formik.errors.new_home_purchase_price)) {
            ele = document.getElementById("loanofficer")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "downpaymentequity" && (!formik.errors.equity_unlock_requested)) {
            ele = document.getElementById("loanofficer")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "loanofficer" && (!formik.errors.loan_officer)) {
            ele = document.getElementById("realestate")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "realestate" && (!formik.errors.real_estate_agent)) {
            ele = document.getElementById("howdidyouhear")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "howdidyouhear" && (!formik.errors.hear_about_us_option_id)) {
            ele = document.getElementById("about")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "about" && (!formik.errors.bedrooms)) {
            ele = document.getElementById("majorimprovements")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "majorimprovements" && (!formik.errors.major_improvements)) {
            ele = document.getElementById("built")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "built" && (!formik.errors.property_not_sure)) {
            ele = document.getElementById("features")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }
        if (e === "property" && (!formik.errors.property_build_year)) {
            ele = document.getElementById("propert_title")
            if (ele) {
                ele.scrollIntoView({ behavior: "instant", block: "end", inline: "nearest", })
                handleProgress(e)
            }
        }
        if (e === "readytosell" && (!formik.errors.property_build_year)) {
            ele = document.getElementById("ready_to_sell")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "features" && (!formik.errors.special_feature)) {
            ele = document.getElementById("view")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "view" && (!formik.errors.home_view)) {
            ele = document.getElementById("flooringtypes")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "flooringtypes" && (!formik.errors.property_flooring)) {
            ele = document.getElementById("countertops")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "countertops" && (!formik.errors.property_kitchen_countertops)) {
            ele = document.getElementById("sellhome")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "sellhome" && (!formik.errors.property_ready_to_sell)) {
            ele = document.getElementById("planinghome")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "planinghome" && (!formik.errors.planning_to_buy_new_home)) {
            ele = document.getElementById("homeconcern")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "homeconcern" && (!formik.errors.property_reason_for_sale)) {
            ele = document.getElementById("submit")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }
        if (e === "eligibility") {
            ele = document.getElementById("verify")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest", })
                handleProgress(e)
            }
        }
        if (e === "homefacts") {
            ele = document.getElementById("homefacts_section")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }
        if (e === "preference") {
            ele = document.getElementById("preference_section")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
                handleProgress(e)
            }
        }

        if (e === "reset_email") {
            ele = document.getElementById("moreinfo")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })

            }
        }

        handleProgress()

        if (e === "owner") {
            setValidateDisplay0(true)
        } else if (e === "verify") {
            setValidateDisplay(true)
        } else if (e === "moreinfo") {
            setValidateDisplay1(true)
        } else if (e === "financehistory") {
            setValidateDisplay2(true)
        } else if (e === "estimate") {
            setValidateDisplay3(true)
        } else if (e === "association") {
            setValidateDisplay4(true)
        } else if (e === "condition") {
            setValidateDisplay5(true)
            setValidateDisplay16(true)
        } else if (e === "loanofficer") {
            setValidateDisplay6(true)
        } else if (e === "realestateagent") {
            setValidateDisplay7(true)
        } else if (e === "howdidyouhear") {
            setValidateDisplay8(true)
        } else if (e === "newhome") {
            setValidateDisplay9(true)
        } else if (e === "downpaymentequity") {
            setValidateDisplay11(true)
        }
    }
    const ValidateFinalError = async () => {
        await formik.setErrors(validate(formik.values))
        setValidateDisplay(true)
        setValidateDisplay0(true)
        setValidateDisplay1(true)
        setValidateDisplay2(true)
        setValidateDisplay3(true)
        setValidateDisplay4(true)
        setValidateDisplay5(true)
        setValidateDisplay6(true)
        setValidateDisplay7(true)
        setValidateDisplay8(true)
        setValidateDisplay9(true)
        setValidateDisplay10(true)
        setValidateDisplay11(true)
        setValidateDisplay16(true)
        setValidateDisplay18("contentID")
        setEmailError(true)
        handleVerifyerror()
    }
    const handleVerifyerror = async () => {
        await formik.validateForm();
        let errors = validate(formik.values)
        let ele;
        if (Object.keys(errors).includes("property_type_id")) {
            ele = document.getElementById("owner")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            }
        }
        else if (Object.keys(errors).includes("non_owner_comments")) {
            ele = document.getElementById("verify")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            }
        }
        else if (Object.keys(errors).includes("customer_email")) {
            ele = document.getElementById("moreinfo")
            if (ele && emailEditErr === false) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            }
        }
        else if (Object.keys(errors).includes("customer_email_last")) {
            ele = document.getElementById("submit")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            }
        }
        else if (Object.keys(errors).includes("finance_history")) {
            ele = document.getElementById("financehistory")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            }
        }
        else if (Object.keys(errors).includes("monthly_dues")) {
            ele = document.getElementById("association")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            }
        }
        else if (Object.keys(errors).includes("property_overall_condition")) {
            ele = document.getElementById("condition")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            }
        }
        else if (Object.keys(errors).includes("new_home_purchase_price")) {
            ele = document.getElementById("newhome")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            }
        }
        else if (Object.keys(errors).includes("loan_officer")) {
            ele = document.getElementById("loanofficer")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            }
        }
        else if (Object.keys(errors).includes("real_estate_agent")) {
            ele = document.getElementById("realestate")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            }
        }
        else if (Object.keys(errors).includes("hear_about_us_option_id")) {
            ele = document.getElementById("howdidyouhear")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            }
        }
    }
    const getEstimateButton = () => {
        setValidateDisplay17("token")
        setValidateDisplay18("contentID")
        let captcha = document.getElementById("recaptcha")
        if (captcha) {
            window.grecaptcha.reset()
        }
    }
    const drawerHandleOpen = () => {
        setValidateDisplay17("bannerID");
        handleScrollOpen()
    }
    const drawerHandleClose = () => {
        setValidateDisplay(false)
        setValidateDisplay0(false)
        setValidateDisplay1(false)
        setValidateDisplay2(false)
        setValidateDisplay3(false)
        setValidateDisplay4(false)
        setValidateDisplay5(false)
        setValidateDisplay6(false)
        setValidateDisplay7(false)
        setValidateDisplay8(false)
        setValidateDisplay9(false)
        setValidateDisplay10(false)
        setValidateDisplay11(false)
        setValidateDisplay16(false)
        setSubmitSuccess(false)
        setDisplayError(false)
        setSubmitValidationSuccess(false)
        setValidateDisplay17("token");
        setValidateDisplay18("token");
        setErrDisplay(true)
        handleScrollClose();
        if (gaUserNotAnswered === false) {
            GAEventTrackerQuesttionaire("UserVisitedNotSubmitted", 1)
        }
    }
    const drawerHandleOpenHome = () => {
        setValidateDisplay17("token");
        setValidateDisplay18("tokenID");
        handleScrollOpenHome();
        let captcha = document.getElementById("recaptcha")
        if (captcha) {
            setTimeout(() => {
                window.grecaptcha.reset()
            }, 1000);
        }
    }
    const handleReset = (e) => {
        // Validation Operation except finall email address
        if (emailEdit === false) {
            formik.validateForm();
        }
        if (((old_address === formik.values.property_address.street_address) && (old_property_type_id === formik.values.property_type_id)) === true) {
            setResetPadding('')
        } else {
            var ele = document.getElementById("verify")
            if (ele) {
                ele.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest", })
            }
            setOldAddress(formik.values.property_address.street_address);
            setOldPropertyID(formik.values.property_type_id);
            setPropertyID(null)
            setCaptchaVisible(true)
            setPageNumber(1);
            setShowNxtButton(false)
            setErrorMessage()
            setResetPadding('pt-5')
            setEmailOneDisable(false)
            formik.values.property_id = null
            formik.values.is_owner = '';
            formik.values.non_owner_comments = '';
            formik.values.is_primary_residence = '';
            formik.values.non_resident_comments = '';
            formik.values.customer_info.customer_first_name = '';
            formik.values.customer_info.customer_last_name = '';
            formik.values.customer_info.customer_email = '';
            formik.values.customer_info.customer_phone_no = '';
            formik.values.purchased_date = null;
            formik.values.price_paid = '';
            formik.values.total_mortgage = '';
            formik.values.total_mortgage_amount = '';
            formik.values.estimate = '';
            formik.values.appraised_value = '';
            formik.values.estimate_date = null;
            formik.values.home_worth = '';
            formik.values.estimate_appraised = '';
            formik.values.new_home_purchase_price = '';
            formik.values.is_equity_required = '';
            formik.values.equity_unlock_requested = null;
            formik.values.fees_amount = '';
            formik.values.other_fees_comment = '';
            formik.values.other_fees = '';
            formik.values.property_overall_condition_id = '';
            formik.values.bedrooms = 0;
            formik.values.full_bathrooms = 0;
            formik.values.partial_bathrooms = 0;
            formik.values.other_bedrooms = 0;
            formik.values.property_build_year = '';
            formik.values.property_in_sqft = '';
            formik.values.garage_type = '';
            formik.values.garage_parking_count = 0;
            formik.values.property_major_improvement_confirm = [];
            formik.values.property_special_feature_id = [];
            formik.values.property_special_feature_id = null;
            formik.values.property_special_feature_id = '';
            formik.values.other_features = null;
            formik.values.home_view_id = [];
            formik.values.home_view_id = null;
            formik.values.home_view_id = '';
            formik.values.property_flooring_id = [];
            formik.values.property_flooring_id = null;
            formik.values.property_flooring_id = '';
            formik.values.property_kitchen_countertops_id = null;
            formik.values.property_ready_to_sell_id = null;
            formik.values.planning_to_buy_new_home = null;
            formik.values.property_reason_for_sale_id = null;
            formik.values.customer_info.customer_email_last = "";
            formik.values.is_loan_officer = "";
            formik.values.loan_officer = null;
            formik.values.loan_officer_info.first_name = '';
            formik.values.loan_officer_info.last_name = '';
            formik.values.loan_officer_info.email = '';
            formik.values.loan_officer_info.phone_number = '';
            formik.values.is_real_estate_agent = '';
            formik.values.real_estate_agent = null;
            formik.values.real_estate_agent_info.first_name = '';
            formik.values.real_estate_agent_info.last_name = '';
            formik.values.real_estate_agent_info.email = '';
            formik.values.real_estate_agent_info.phone_number = '';
            formik.values.hear_about_us_option_id = null;
            formik.values.is_any_defects = "";
            formik.values.property_defect_id = [];
            formik.values.alteration_1 = "";
            formik.values.alteration_2 = "";
            formik.values.any_settling = "";
            formik.values.flooding = "";
            formik.values.major_damage = "";
            setEmailValue("")
        }
    }
    const handleLocationGet = () => {
        if (formik.values && formik.values.property_address.street_address !== '') {
            formik.values.property_address.street_address = '';
            formik.values.property_address.zip_code = null;
            formik.values.property_address.state = '';
            formik.values.property_address.city = '';
            formik.values.property_address.county = '';
            formik.values.property_type_id = null;
        }
    }
    const handleLocation = () => {
        if (formik.values && formik.values.property_address_get.street_address !== '') {
            formik.values.property_address_get.street_address = '';
            formik.values.property_address_get.zip_code = null;
            formik.values.property_address_get.state = '';
            formik.values.property_address_get.city = '';
            formik.values.property_address_get.county = '';
        }
    }
    const handleZipCode = () => {
        if (addr === null) {
            addr = formik.values.property_address_get.street_address;
        } else if (addr !== formik.values.property_address_get.street_address) {
            setOldAddress(formik.values.property_address_get.street_address)
        }
        setSubmitValidationSuccess(true)
        let postData = {
            "zip_code": formik.values && formik.values.property_address.zip_code ? formik.values.property_address.zip_code :formik.values.property_address_get.zip_code
        }
        let authorise = process.env.REACT_APP_API_KEY
        fetch(`${config.baseUrlCP}validate-zipcode/`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `${authorise}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(postData),
            })
            .then(async response => {
                const results = await response.json()
                if (response.status === 201 || response.status === 200) {
                    props.GAtimerFinish()
                    setZipCodeExists(results.is_operating_area)
                    if (results.is_operating_area == false) {
                        setOpenCalque(true)
                        setErrDisplay(false)
                    } else {
                        setOpenCalque(false)
                        if (formik.values.property_address_get.zip_code) {
                            drawerHandleOpenHome();
                        }
                        handleReset();
                        setErrDisplay(false)
                    }
                    if (Object.keys(formik.errors).length !== 0 && formik.errors.property_type == undefined && formik.errors.street_address == undefined) {
                        GAEventTracker("UserEnteredQuestionnaire", 1)
                    }
                }
                else {
                    setZipcodeEmptyErr(results.zip_code[0])
                    setOpenCalque(false)
                    setErrDisplay(false)
                }
            })
            .catch((error) => {
            })
    }
    const handlePopupSubmit = values => {
        validatePopUp()
        var postUserQue = {
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.email,
            "location": props.values && props.values.property_address.street_address,
            partner_id: props?.partner?.partner_id ? props.partner.partner_id : null,
        }
        let authorise = process.env.REACT_APP_API_KEY
        fetch(`${config.baseUrlCP}email-for-validate-zipcode/`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `${authorise}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(postUserQue),
            })
            .then(async response => {
                const results = await response.json()
                if (response.status === 201 || response.status === 200) {
                    GAEventTracker("User Detail Submit from Non Operating Area", 1)
                    setDetail(results.message);
                    setSeverityType("success");
                    setOpenSnackbar(true)
                    formik.setFieldValue('first_name', '')
                    formik.setFieldValue('last_name', '')
                    formik.setFieldValue('email', '')
                    formik.setFieldValue('location', '')
                    setOpenCalque(false)
                }
                else {
                    if (results.detail) {
                        setDetail(results.message)
                        setSeverityType("error");
                        setOpenSnackbar(true)
                        formik.setFieldValue('first_name', '')
                        formik.setFieldValue('last_name', '')
                        formik.setFieldValue('email', '')
                        formik.setFieldValue('user_question', '')
                        await sleep(2000);
                    } else {
                        setSeverityType("error");
                    }
                }
            })
            .catch((error) => {
                setDetail("Something Went Wrong!")
                setSeverityType("error");
                setOpenSnackbar(true)
            })
    }
    const handleClickOpener = () => {
        setOpenCalque(!openCalque)
    };

    useEffect(() => {
        if (!formik.errors.non_owner_comments) {
            setValidateDisplay(false)
        } else if (!formik.errors.customer_email) {
            setValidateDisplay1(false)
        } else if (!formik.errors.finance_history) {
            setValidateDisplay2(false)
        } else if (!formik.errors.monthly_dues) {
            setValidateDisplay4(false)
        } else if (!formik.errors.property_overall_condition) {
            setValidateDisplay5(false)
        } else if (!formik.errors.loan_officer) {
            setValidateDisplay6(false)
        } else if (!formik.errors.real_estate_agent) {
            setValidateDisplay7(false)
        } else if (!formik.errors.hear_about_us_option_id) {
            setValidateDisplay8(false)
        } else if (!formik.errors.new_home_purchase_price) {
            setValidateDisplay9(false)
        } else if (!formik.errors.captcha_error_msg) {
            setValidateDisplay10(false)
        } else if (!formik.errors.equity_unlock_requested) {
            setValidateDisplay11(false)
        }
    })
    useEffect(() => {
        if (props.location === true) {
            if ((props.old_address === props.values.property_address.street_address)) {
            } else {
                handleReset()
            }
        }
    })
    useEffect(() => {
        let tempProgress = 0
        if (formik.values.property_address.street_address || formik.values.property_address.street_address !== '') {
            tempProgress += 0
        } else if (formik.values.property_address.zip_code !== null) {
            tempProgress += 0
        }
        if (formik.values.property_type_id !== null) {
            tempProgress += 0
        }
        if ((formik.values.is_owner === "yes" && formik.values.is_primary_residence) || (formik.values.is_owner === "no" && formik.values.non_owner_comments !== "")) {
            tempProgress += 5.88
        }
        if (formik.values.customer_info.customer_email !== '' && formik.values.customer_info.customer_first_name !== '' && formik.values.customer_info.customer_last_name !== '') {
            tempProgress += 5.88
        } else if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formik.values.customer_info.customer_email) === true) {
            tempProgress += 5.88
        }
        if ((formik.values.price_paid !== '' && formik.values.price_paid !== '$') && (formik.values.home_worth !== '' && formik.values.home_worth !== '$') && (formik.values.estimate !== '' && formik.values.estimate === 'no')) {
            tempProgress += 5.88
        } else if (formik.values.estimate === "yes" && ((formik.values.total_mortgage !== '' && formik.values.total_mortgage !== '$') || (formik.values.total_mortgage_amount && formik.values.total_mortgage !== '$'))) {
            tempProgress += 5.88
        }
        if ((formik.values.estimate_appraised && formik.values.home_worth)) {
            tempProgress += 5.88
        } else if (formik.values.estimate_appraised === 'yes' && formik.values.appraised_value) {
            tempProgress += 5.88
        }
        if (formik.values.other_fees === "no") {
            tempProgress += 5.88
        } else if (formik.values.other_fees === "yes" && (formik.values.fees_amount !== '' && formik.values.fees_amount !== '$')) {
            tempProgress += 5.88
        }
        // if (formik.values.property_overall_condition_id !== null && formik.values.property_overall_condition_id !== "") {
        //     tempProgress += 6.68
        // }
        if (formik.values.new_home_purchase_price !== null && formik.values.new_home_purchase_price !== '' && formik.values.new_home_purchase_price !== "$") {
            tempProgress += 5.88
        }
        if (formik.values.is_equity_required === "false" || (formik.values.is_equity_required === "true" && formik.values.equity_unlock_requested !== '')) {
            tempProgress += 5.88
        }
        if (formik.values.is_loan_officer !== "" && formik.values.is_loan_officer === "false") {
            tempProgress += 5.88
        } else if ((formik.values.is_loan_officer === "true" && formik.values.is_loan_officer !== "false") && (formik.values.loan_officer !== null)) {
            tempProgress += 5.88
        }
        if (formik.values.is_real_estate_agent !== "" && formik.values.is_real_estate_agent === "false") {
            tempProgress += 5.88
        } else if ((formik.values.is_real_estate_agent === "true" && formik.values.is_real_estate_agent !== "false") && (formik.values.real_estate_agent !== null)) {
            tempProgress += 5.88
        }
        if (formik.values.hear_about_us_option_id !== null && formik.values.hear_about_us_option_id !== "") {
            tempProgress += 5.88
        }
        if (formik.values.condo_unit_number || formik.values.condo_association_name || formik.values.property_build_year || formik.values.property_in_sqft || formik.values.garage_type || formik.values.property_not_sure) {
            tempProgress += 6.68
        }
        if (formik.values.septic === "yes" || formik.values.septic === "no") {
            tempProgress += 6.68
        }
        if (formik.values.property_overall_condition_id !== null && formik.values.property_overall_condition_id !== "") {
            tempProgress += 6.68
        }
        if (formik.values.property_defect_id.length > 0 ) {
            tempProgress += 6.68
        }
        if (formik.values.alteration_1 !== "" || formik.values.alteration_2 !== "" || formik.values.any_settling !== "" || formik.values.flooding !== "" || formik.values.major_damage !== "") {
            tempProgress += 6.68
        }
        if (formik.values.property_ready_to_sell_id !== null) {
            tempProgress += 6.68
        }
        if (formik.values.property_reason_for_sale_id !== null) {
            tempProgress += 6.68
        }
        setProgress(tempProgress)
    });
    useEffect(() => {
        /** google analytics question by question event post */
        if (questionGA1Capture === false) {
            if (formik.values.is_owner === "yes" || (formik.values.is_owner === "no" && formik.values.non_owner_comments !== "")) {
                GAEventTrackerQuesttionaire("Eligibility_OwnandOccupy?", 1)
                setQuestionGA1Capture(true)
            }
        }
        if (questionGA2Capture === false) {
            if (formik.values.customer_info.customer_email !== '' && formik.values.customer_info.customer_first_name !== '' && formik.values.customer_info.customer_last_name !== '') {
                GAEventTrackerQuesttionaire("Eligibility_GiveLittleMore?", 1)
                setQuestionGA2Capture(true)
            } else if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formik.values.customer_info.customer_email) === true) {
                GAEventTrackerQuesttionaire("Eligibility_GiveLittleMore?", 1)
                setQuestionGA2Capture(true)
            }
        }
        if (questionGA3Capture === false) {
            if (formik.values.price_paid && formik.values.estimate) {
                GAEventTrackerQuesttionaire("Eligibility_PurchaseandFinance?", 1)
                setQuestionGA3Capture(true)
            } else if ((formik.values.estimate === "This is original mortgage amount" && (formik.values.total_mortgage || formik.values.total_mortgage_amount)) || (formik.values.estimate === "This is current unpaid balance" && (formik.values.total_mortgage || formik.values.total_mortgage_amount))) {
                GAEventTrackerQuesttionaire("Eligibility_PurchaseandFinance?", 1)
                setQuestionGA3Capture(true)
            }
        }
        if (questionGA5Capture === false) {
            if (formik.values.other_fees) {
                GAEventTrackerQuesttionaire("Eligibility_MonthlyDuesorFees?", 1)
                setQuestionGA5Capture(true)
            } else if (formik.values.other_fees === "yes" && formik.values.fees_amount) {
                GAEventTrackerQuesttionaire("Eligibility_MonthlyDuesorFees?", 1)
                setQuestionGA5Capture(true)
            }
        }
        if (questionGA6Capture === false) {
            if (formik.values.property_overall_condition_id !== null && formik.values.property_overall_condition_id !== "") {
                GAEventTrackerQuesttionaire("Eligibility_RateOverallCondition?", 1)
                setQuestionGA6Capture(true)
            }
        }
        if (questionGA20Capture === false) {
            if (formik.values.new_home_purchase_price !== null && formik.values.new_home_purchase_price !== "$" && formik.values.new_home_purchase_price !== '') {
                GAEventTrackerQuesttionaire("Eligibility_MaxPriceOfNewHome?", 1)
                setQuestionGA20Capture(true)
            }
        }
        if (questionGA7Capture === false) {
            if (formik.values.is_loan_officer !== "") {
                GAEventTrackerQuesttionaire("Eligibility_LoanOfficer?", 1)
                setQuestionGA7Capture(true)
            }
        }
        if (questionGA8Capture === false) {
            if (formik.values.is_real_estate_agent !== "") {
                GAEventTrackerQuesttionaire("Eligibility_RealEstateAgent?", 1)
                setQuestionGA8Capture(true)
            }
        }
        if (questionGA9Capture === false) {
            if (formik.values.hear_about_us_option_id !== null && formik.values.hear_about_us_option_id !== "") {
                GAEventTrackerQuesttionaire("Eligibility_HearAboutUs?", 1)
                setQuestionGA9Capture(true)
            }
        }
        if (questionGA10Capture === false) {
            if (formik.values.bedrooms > 0 || formik.values.full_bathrooms > 0 || formik.values.partial_bathrooms > 0 || formik.values.other_bedrooms > 0) {
                GAEventTrackerQuesttionaire("HomeFacts_TellLittleMore?", 1)
                setQuestionGA10Capture(true)
            }
        }
        if (questionGA11Capture === false) {
            if ((formik.values.property_major_improvement_confirm === 'yes' && formik.values.property_major_improvements_id.length > 0) || (formik.values.property_major_improvement_confirm === 'no')) {
                GAEventTrackerQuesttionaire("HomeFacts_MajorImprove?", 1)
                setQuestionGA11Capture(true)
            }
        }
        if (questionGA12Capture === false) {
            if (formik.values.property_build_year || formik.values.property_in_sqft || formik.values.garage_type || formik.values.property_not_sure) {
                GAEventTrackerQuesttionaire("HomeFacts_PropertyDetails?", 1)
                setQuestionGA12Capture(true)
            }
        }
        if (questionGA13Capture === false) {
            if (formik.values.property_special_feature_id.length > 0) {
                GAEventTrackerQuesttionaire("HomeFacts_SpecialFeatures?", 1)
                setQuestionGA13Capture(true)
            }
        }
        if (questionGA14Capture === false) {
            if (formik.values.home_view_id.length > 0) {
                GAEventTrackerQuesttionaire("HomeFacts_MainView?", 1)
                setQuestionGA14Capture(true)
            }
        }
        if (questionGA15Capture === false) {
            if (formik.values.property_flooring_id.length > 0) {
                GAEventTrackerQuesttionaire("HomeFacts_MainTypesFlooring?", 1)
                setQuestionGA15Capture(true)
            }
        }
        if (questionGA16Capture === false) {
            if (formik.values.property_kitchen_countertops_id !== null) {
                GAEventTrackerQuesttionaire("HomeFacts_CountertopsKitchen?", 1)
                setQuestionGA16Capture(true)
            }
        }
        if (questionGA17Capture === false) {
            if (formik.values.property_ready_to_sell_id !== null) {
                GAEventTrackerQuesttionaire("Preferences_ReadyToSell?", 1)
                setQuestionGA17Capture(true)
            }
        }
        if (questionGA18Capture === false) {
            if (formik.values.planning_to_buy_new_home) {
                GAEventTrackerQuesttionaire("Preferences_PlanningToBuy?", 1)
                setQuestionGA18Capture(true)
            }
        }
        if (questionGA19Capture === false) {
            if (formik.values.property_reason_for_sale_id !== null) {
                GAEventTrackerQuesttionaire("Preferences_BiggestConcern?", 1)
                setQuestionGA19Capture(true)
            }
        }
        /** google analytics section by section event post */
        if (sectionEligibilityGA === false) {
            if ((formik.values.is_owner === "yes" || (formik.values.is_owner === "no" && formik.values.non_owner_comments !== "")) && (formik.values.customer_info.customer_email !== '' && formik.values.customer_info.customer_first_name !== '' && formik.values.customer_info.customer_last_name !== '')
                && (formik.values.price_paid && formik.values.estimate || (formik.values.estimate === "This is original mortgage amount" && (formik.values.total_mortgage || formik.values.total_mortgage_amount)) || (formik.values.estimate === "This is current unpaid balance" && (formik.values.total_mortgage || formik.values.total_mortgage_amount)))
                && (formik.values.property_overall_condition_id !== null && formik.values.property_overall_condition_id !== "")
                && (formik.values.other_fees || (formik.values.other_fees === "yes" && formik.values.fees_amount))
                && (formik.values.new_home_purchase_price !== null && formik.values.new_home_purchase_price !== "$" && formik.values.new_home_purchase_price !== '')
                && (formik.values.is_loan_officer !== "")
                && (formik.values.is_real_estate_agent !== "")
                && (formik.values.hear_about_us_option_id !== null && formik.values.hear_about_us_option_id !== "")
            ) {
                GAEventTrackerSection("ELIGIBILITY_COMPLETED", 1)
                setSectionEligibityGA(true)
            }
        }
        if (sectionEligibilityGAPartial === false) {
            if ((formik.values.is_owner === "yes" || (formik.values.is_owner === "no" && formik.values.non_owner_comments !== "")) || (formik.values.customer_info.customer_email !== '' && formik.values.customer_info.customer_first_name !== '' && formik.values.customer_info.customer_last_name !== '')
                || (formik.values.price_paid && formik.values.estimate || (formik.values.estimate === "This is original mortgage amount" && (formik.values.total_mortgage || formik.values.total_mortgage_amount)) || (formik.values.estimate === "This is current unpaid balance" && (formik.values.total_mortgage || formik.values.total_mortgage_amount)))
                || (formik.values.property_overall_condition_id !== null && formik.values.property_overall_condition_id !== "")
                || (formik.values.other_fees || (formik.values.other_fees === "yes" && formik.values.fees_amount))
                || (formik.values.new_home_purchase_price !== null && formik.values.new_home_purchase_price !== "$" && formik.values.new_home_purchase_price !== '')
                || (formik.values.is_loan_officer !== "")
                || (formik.values.is_real_estate_agent !== "")
                || (formik.values.hear_about_us_option_id !== null && formik.values.hear_about_us_option_id !== "")
            ) {
                GAEventTrackerSection("ELIGIBILITY", 1)
                setSectionEligibityGAPartial(true)
            }
        }
        if (sectionHomeFactsGA === false) {
            if ((formik.values.bedrooms > 0 || formik.values.full_bathrooms > 0 || formik.values.partial_bathrooms > 0 || formik.values.other_bedrooms > 0)
                && (formik.values.property_major_improvement_confirm === 'yes' && formik.values.property_major_improvements_id.length > 0) || (formik.values.property_major_improvement_confirm === 'no')
                && (formik.values.property_build_year !== "" || formik.values.property_in_sqft !== "" || formik.values.garage_type !== "" || formik.values.property_not_sure !== null)
                && (formik.values.property_special_feature_id.length > 0)
                && (formik.values.home_view_id.length > 0)
                && (formik.values.property_flooring_id.length > 0)
                && (formik.values.property_kitchen_countertops_id !== null)
            ) {
                GAEventTrackerSection("HOMEFACTS_COMPLETED", 1)
                setSectionHomeFactsGA(true)
            }
        }
        if (sectionHomeFactsGAPartial === false) {
            if ((formik.values.bedrooms > 0 || formik.values.full_bathrooms > 0 || formik.values.partial_bathrooms > 0 || formik.values.other_bedrooms > 0)
                || (formik.values.property_major_improvement_confirm === 'yes' && formik.values.property_major_improvements_id.length > 0) || (formik.values.property_major_improvement_confirm === 'no')
                || (formik.values.property_build_year || formik.values.property_in_sqft || formik.values.garage_type || formik.values.property_not_sure)
                || (formik.values.property_special_feature_id.length > 0)
                || (formik.values.home_view_id.length > 0)
                || (formik.values.property_flooring_id.length > 0)
                || (formik.values.property_kitchen_countertops_id !== null)
            ) {
                GAEventTrackerSection("HOMEFACTS", 1)
                setSectionHomeFactsGAPartial(true)
            }
        }
        if (sectionPreferenceGA === false) {
            if ((formik.values.property_ready_to_sell_id !== null)
                && (formik.values.planning_to_buy_new_home != "")
                && (formik.values.property_reason_for_sale_id !== null)
            ) {
                GAEventTrackerSection("PREFERENCES_COMPLETED", 1)
                setSectionPreferenceGA(true)
            }
        }
        if (sectionPreferenceGAPartial === false) {
            if ((formik.values.property_ready_to_sell_id !== null)
                || (formik.values.planning_to_buy_new_home)
                || (formik.values.property_reason_for_sale_id !== null)
            ) {
                GAEventTrackerSection("PREFERENCES", 1)
                setSectionPreferenceGAPartial(true)
            }
        }
    }, [formik && formik.values])

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }
    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    function calqueMarket() {
        return (
            <>
                <div className="container d-none d-md-block">
                    <div className="row">
                        <div className="col-6 p-5">
                            <h2 className="jost-bold">WE'RE WORKING ON IT!</h2>
                            <p className="pt-4">Thanks for your interest in The Trade-In Mortgage™!Calque is not currently operating in your market, but
                                we’re expanding fast.</p>
                            <p>If you give us your name and email, we will reach out once we arrive.</p>
                        </div>
                        <div className="col-6">
                            <div className="col-12 top-padding-small py-3">
                                <h6>Name</h6>
                                <div className="row">
                                    <div className="col-6">
                                        <TextField
                                            className="w-100"
                                            placeholder="First Name"
                                            type="text"
                                            name="first_name"
                                            onChange={formik.handleChange}
                                            onBlur={validatePopUp}
                                            value={formik.values.first_name}
                                            variant="outlined"
                                        />
                                        {popError.first_name != "" ?
                                            <div className="error-msg">{popError.first_name}</div> : ''
                                        }
                                    </div>
                                    <div className="col-6">
                                        <TextField
                                            className="w-100"
                                            placeholder="Last Name"
                                            name="last_name"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={validatePopUp}
                                            value={formik.values.last_name}
                                            variant="outlined"
                                        />
                                        {popError.last_name != "" ?
                                            <div className="error-msg">{popError.last_name}</div> : ''
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 py-3">
                                <h6>Email Address</h6>
                                <div className="row">
                                    <div className="col-12">
                                        <TextField
                                            placeholder="Email"
                                            variant="outlined"
                                            name="email"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={validatePopUp}
                                            value={formik.values.email}
                                            className="w-100"
                                        />
                                        {popError.email != "" ?
                                            <div className="error-msg">{popError.email}</div> : ''
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 py-3">
                                <div className="row">
                                    <div className="col-12">
                                        <Button
                                            disableelevation="true"
                                            variant="contained"
                                            color="inherit"
                                            className="w-100"
                                            style={{ height: '50px', backgroundColor: '#FBC04E' }}
                                            onClick={(e) => { handlePopupSubmit(formik.values) }}
                                        >
                                            Submit Now
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container d-block d-md-none">
                    <div>
                        <div className="p-2">
                            <h2 className="jost-bold">WE'RE WORKING ON IT!</h2>
                            <p className="pt-4">Thanks for your interest in The Trade-In Mortgage™!Calque is not currently operating in your market, but
                                we’re expanding fast.</p>
                            <p>If you give us your name and email, we will reach out once we arrive.</p>
                        </div>
                        <div>
                            <div className="top-padding-small py-3">
                                <h6>Name</h6>
                                <div>
                                    <div>
                                        <TextField
                                            className="w-100"
                                            placeholder="First Name"
                                            type="text"
                                            name="first_name"
                                            onChange={formik.handleChange}
                                            onBlur={validatePopUp}
                                            value={formik.values.first_name}
                                            variant="outlined"
                                        />
                                        {popError.first_name != "" ?
                                            <div className="error-msg">{popError.first_name}</div> : ''
                                        }
                                    </div>
                                </div>
                                <div className="pt-3">
                                    <div>
                                        <TextField
                                            className="w-100"
                                            placeholder="Last Name"
                                            name="last_name"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={validatePopUp}
                                            value={formik.values.last_name}
                                            variant="outlined"
                                        />
                                        {popError.last_name != "" ?
                                            <div className="error-msg">{popError.last_name}</div> : ''
                                        }
                                    </div>

                                </div>
                            </div>
                            <div className="py-3">
                                <h6>Email Address</h6>
                                <div>
                                    <div>
                                        <TextField
                                            placeholder="Email"
                                            variant="outlined"
                                            name="email"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={validatePopUp}
                                            value={formik.values.email}
                                            className="w-100"
                                        />
                                        {popError.email != "" ?
                                            <div className="error-msg">{popError.email}</div> : ''
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="py-3">
                                <div>
                                    <Button
                                        disableelevation="true"
                                        variant="contained"
                                        color="inherit"
                                        className="w-100"
                                        style={{ height: '50px', backgroundColor: '#FBC04E' }}
                                        onClick={(e) => { handlePopupSubmit(formik.values) }}
                                    >
                                        Submit Now
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    function Contactus() {
        return (
            <>
                <div className="container-fluid m-0 top-padding-small bottom-padding-main px-md-5">
                    <div className="row px-md-5">
                        <div className="col-12 px-md-5">
                            <div className="justify-content-md-between align-items-md-center">
                                <h3 className="headerfont">Contact Us</h3>
                                <div className="contentfonthead">To speak with a Calque representative, call</div>
                                <div className="contentfont">
                                    <a className="tel" href={`tel:${props?.contactGlobal?.application_config_value}`} style={{ cursor: 'pointer', color: 'black' }}>
                                        <b>{props?.contactGlobal?.application_config_value}</b>
                                    </a>
                                </div>
                                <div className="contentfonthead">Or send an email to</div>
                                <div className="contentfont">
                                    <a className="mailto" href={`mailto:${props?.emailGlobal?.application_config_value}`} style={{ cursor: 'pointer', color: 'black' }}>
                                        <b>{props?.emailGlobal?.application_config_value}</b>
                                    </a>
                                </div>
                                <div className="contentfonthead">Our address is</div>
                                <div className="contentfont">
                                    <b>
                                        <p className="contactAddress">
                                            {props?.addressGlobal?.application_config_value}
                                        </p>
                                    </b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
    function SendOffer() {
        return (
            <>
                <div className="container-fluid m-0 top-padding-small bottom-padding-main px-md-5">
                    <div className="row px-md-5">
                        <div className="col-12 px-md-5">
                            <div className="justify-content-md-between align-items-md-center">
                                <h4 className="headerfont text-dark save-popup">We got your info!</h4>
                            </div>
                        </div>
                    </div>
                    <div className="row px-md-5">
                        <div className="col-12 px-md-5 pt-5">
                            <div className="d-flex justify-content-center">
                                <Button
                                    variant="contained" disableelevation="true"
                                    color="primary"
                                    type="submitt"
                                    className="jost-bold"
                                    style={{ height: '38px', width: '94px', color: 'white', backgroundColor: '#2661AB' }}
                                    {...{
                                        "aria-haspopup": "true",
                                        onClick: handlePopUpClose,
                                    }}
                                >
                                    OK
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
    function Sendfailure() {
        return (
            <>
                <div className="container-fluid m-0 top-padding-small bottom-padding-main px-md-5">
                    <div className="row px-md-5">
                        <div className="col-12 px-md-5">
                            <div className="justify-content-md-between align-items-md-center">
                                <h4 className="headerfont text-danger">Sorry for the Inconvenience ! Unfortunately your Data is Not Saved, Please fill it Again</h4>
                            </div>
                        </div>
                    </div>
                    <div className="row px-md-5">
                        <div className="col-12 px-md-5 pt-5">
                            <div className="d-flex justify-content-center">
                                <Button
                                    variant="contained" disableelevation="true"
                                    color="primary"
                                    type="submitt"
                                    className="jost-bold"
                                    style={{ height: '38px', width: '94px', color: 'white', backgroundColor: '#2661AB' }}
                                    {...{
                                        "aria-haspopup": "true",
                                        onClick: handlePopUpClose1,
                                    }}
                                >
                                    OK
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <div className="top-margin-main">
            <form onSubmit={formik.handleSubmit} noValidate>
                <div className="container-fluid p-0 m-0">
                    <div className="">
                        <div>
                            <BannerRealtor
                                {...props}
                                handleLocation={handleLocation}
                                cdrawer={cdrawer}
                                setErrDisplay={setErrDisplay}
                                errDisplay={errDisplay}
                                cdrawerHome={cdrawerHome}
                                drawerClose={drawerClose}
                                drawerHandleOpen={drawerHandleOpen}
                                myRef={myRef}
                                drawerHandleClose={drawerHandleClose}
                                handleChange={formik.handleChange}
                                values={formik.values}
                                setDisplayPropertyLoc={setDisplayPropertyLoc}
                                displayPropertyLoc={displayPropertyLoc}
                                errors={formik.errors} touched={formik.touched}
                                progress={progress}
                                formik={formik}
                                handleNext={handleNext}
                                validate={formik.validate}
                                submit={formik.handleSubmit}
                                ValidateFinalError={ValidateFinalError}
                                getEstimateButton={getEstimateButton}
                                handleBlur={formik.handleBlur}
                                setEmailEditErr={setEmailEditErr}
                                contactGlobal={props.contactGlobal}
                                emailGlobal={props.emailGlobal}
                                emailEditErr={emailEditErr}
                                validateDisplay={validateDisplay}
                                validateDisplay0={validateDisplay0}
                                validateDisplay1={validateDisplay1}
                                validateDisplay2={validateDisplay2}
                                validateDisplay3={validateDisplay3}
                                validateDisplay4={validateDisplay4}
                                validateDisplay5={validateDisplay5}
                                validateDisplay6={validateDisplay6}
                                validateDisplay7={validateDisplay7}
                                setValidateDisplay6={setValidateDisplay6}
                                setValidateDisplay7={setValidateDisplay7}
                                validateDisplay8={validateDisplay8}
                                validateDisplay9={validateDisplay9}
                                validateDisplay10={validateDisplay10}
                                validateDisplay11={validateDisplay11}
                                setValidateDisplay9={setValidateDisplay9}
                                setValidateDisplay8={setValidateDisplay8}
                                validateDisplay16={validateDisplay16}
                                validateDisplay17={validateDisplay17}
                                validateDisplay18={validateDisplay18}
                                loader={loader}
                                pageNumber={pageNumber}
                                setPageNumber={setPageNumber}
                                isSelectedLo={isSelectedLo}
                                setIsSelectedLo={setIsSelectedLo}
                                isSelectedAgent={isSelectedAgent}
                                setIsSelectedAgent={setIsSelectedAgent}
                                showNxtButton={showNxtButton}
                                setShowNxtButton={setShowNxtButton}
                                handleProgress={handleProgress}
                                captch_visible={captch_visible}
                                setCaptchaVisible={setCaptchaVisible}
                                errorMessage={errorMessage}
                                setErrorMessage={setErrorMessage}
                                loaderNext={loaderNext}
                                setLoaderNext={setLoaderNext}
                                handleReset={handleReset}
                                propertyID={propertyID}
                                setPropertyID={setPropertyID}
                                resetPadding={resetPadding}
                                emailError={emailError}
                                setEmailError={setEmailError}
                                emailEdit={emailEdit}
                                setEmailEdit={setEmailEdit}
                                emailValue={emailValue}
                                setEmailValue={setEmailValue}
                                emailOneDisable={emailOneDisable}
                                setEmailOneDisable={setEmailOneDisable}
                                setValidateControl={setValidateControl}
                                validateControl={validateControl}
                                setSubmitSuccess={setSubmitSuccess}
                                submitSuccess={submitSuccess}
                                setDisplayError={setDisplayError}
                                displayError={displayError}
                                GAtimer={props.GAtimer}
                                GAtimerFinish={props.GAtimerFinish}
                                gaUserNotAnswered={gaUserNotAnswered}
                                setGaUserNotAnswered={setGaUserNotAnswered}
                                setCaptchaValue={setCaptchaValue}
                                captchaValue={captchaValue}
                                old_address={old_address}
                                old_property_type_id={old_property_type_id}
                            />
                        </div>
                    </div>
                    <div>
                    </div>
                    <div className="">
                        <div className="col-md-12 d-sm-block d-md-none py-4">
                            <div className="row">
                                <div className="howitworks_img_mobile w-100">
                                    <img src="/assets/images/howitworks_compressed.webp" alt="How It Works" ></img>
                                </div>
                            </div>
                        </div>
                        <div className="container" >
                            <HowitWorksRealtor {...props} />
                        </div>
                        <div className="container">
                            <WhyChooseRealtor {...props} handleEfficient={handleEfficient} />
                        </div>
                        <div>
                            <div className="bottomfooter d-flex align-items-center justify-content-center" style={{ backgroundColor: `${props.partner.tertiary_color}` ? `${props.partner.tertiary_color}` : '#8E97A7' }}>
                                <div className="text-center px-3 py-4 w-res-75">
                                    <p className="bottomheadpara px-md-5 px-0 m-0" style={{ fontSize: '32px' }}>The Trade-In Mortgage<span style={{ fontSize: '1.7rem', fontFamily: 'system-ui' }}>™</span> can make your real estate buying experience more convenient and affordable.</p>
                                    <div className="d-none d-md-block">
                                        <div className="d-flex">
                                            {/* <div className="w-res-50 pt-1">
                                                <GoogleMapsGet handleReset={handleReset} handleLocationGet={handleLocationGet} handleChange={props.handleChange} values={formik.values} errors={formik.errors} validateDisplay18={props.validateDisplay18} zipcodeEmptyErr={zipcodeEmptyErr} zipcodeExists={zipcodeExists} submitValidationSucces={submitValidationSuccess} setDisplayError={setDisplayError} />
                                            </div>
                                            <div className="pt-3 pl-3 w-res-50">
                                                <Button
                                                    variant="contained" disableelevation="true"
                                                    color="inherit"
                                                    style={{ height: '57px', width: '58%', backgroundColor: `${props.partner.secondary_color}` ? `${props.partner.secondary_color}` : '#2A83C2' }}
                                                    type="button"
                                                    className="jost-bold w-100"
                                                    onClick={(e) => { GAEventTrackerGetStarted("Get started", 1); handleZipCode() }}
                                                    {...{
                                                        "aria-haspopup": "true",
                                                    }}
                                                >
                                                    Get started now
                                                </Button>
                                            </div> */}
                                        </div>
                                            {/* <ApplicationFunnel/> */}
                                    </div>
                                    <div className="" style={{ display:"flex", alignItems:"center", justifyContent:"center" }}>
                                        {/* <div className="w-res-50">
                                            <GoogleMapsGet handleReset={handleReset} handleLocationGet={handleLocationGet} handleChange={props.handleChange} values={formik.values} errors={formik.errors} validateDisplay18={props.validateDisplay18} zipcodeEmptyErr={zipcodeEmptyErr} zipcodeExists={zipcodeExists} setDisplayError={setDisplayError} submitValidationSuccess={submitValidationSuccess} />
                                        </div>
                                        <div className="w-res-75 pt-3">
                                            <Button
                                                variant="contained" disableelevation="true"
                                                color="inherit"
                                                style={{ height: '54px', width: '58%', backgroundColor: `${props.partner.secondary_color}` ? `${props.partner.secondary_color}` : '#2A83C2' }}
                                                type="button"
                                                className="jost-bold w-100"
                                                onClick={(e) => { GAEventTrackerGetStarted("Get started", 1); handleZipCode() }}
                                                {...{
                                                    "aria-haspopup": "true",
                                                }}
                                            >
                                                Get started
                                            </Button>
                                        </div>
                                        <div className="px-md-5 px-0 py-2 d-flex justify-content-center" style={{ fontSize: '14px' }}>
                                        <p className="w-75">
                                        *It's free and only takes 5 minutes! If you prefer to set up a phone call to talk to one of Calque's associates, please&nbsp;
                                        <Link activeclass="active"
                                        to="contact"
                                        spy={true}
                                        validateform="true"
                                        smooth="true"
                                        offset={-70}
                                        duration={500}
                                        style={{ textDecoration: 'underline' }}
                                        onClick={(e) => { GAEventTrackerContactUs("Contact Us", 1); handleClickOpen2() }}>
                                        click here.
                                        </Link>
                                        </p>
                                        </div> */}
                                    <div style={{width: "clamp(300px, 50%, 700px)",
                                                margin: "0 auto",
                                                }}>
                                        <ApplicationFunnel />
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="" id="faq">
                        <div className="container">
                            <FaqRealtor {...props} efficient={efficient} setEfficient={setEfficient} drawerHandleOpenHome={drawerHandleOpenHome} handleReset={handleReset} />
                        </div>
                    </div>
                    <div className="primary-background">
                        <div>
                            <div className="col-md-6 d-md-none d-sm-block p-0">
                                <div className="about_img_mobile">
                                    <img src="/assets/images/aboutuskey1_compressed.webp" alt="About Us Key" ></img>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid" style={{ backgroundColor: `${props.partner.primary_color ? props.partner.primary_color : '#042F70'}` }}>
                            <div className="container text-white padding-bottom-small">
                                <AboutRealtor {...props} />
                            </div>
                        </div>
                        <div className="container-fluid m-0 px-0 montserrat-semibold">
                            <div className="row border-top mx-0" style={{ backgroundColor: `${props.partner.primary_color ? props.partner.primary_color : '#042F70'}` }}>
                                <div className="col-12">
                                    <div className="d-md-flex justify-content-md-between align-items-md-center p-4">
                                        <div className="d-md-block d-none text-white col-md-4">
                                            <span>Have more questions? </span><br />
                                            <span>Send an email to: <a className="mailto" href={`mailto:${props.emailGlobal ? props.emailGlobal.application_config_value : 'info@calqueinc.com'}`} style={{ cursor: 'pointer', color: 'white' }}>{props.emailGlobal && props.emailGlobal != 0 ? props.emailGlobal.application_config_value : 'info@calqueinc.com'}</a></span>
                                            <div className="d-flex align-items-center pt-2">
                                                <div className="pr-2">
                                                    <a target="_blank" href="https://www.linkedin.com/company/calqueinc/" onClick={(e) => { GAEventTrackerFooterLinkedIn('Footer', 1) }}><LinkedInIcon fontSize="large" style={{ color: '#fff', fontSize: '38px' }} /></a>
                                                </div>
                                                <div className="pr-2">
                                                    <a target="_blank" href="https://www.facebook.com/CalqueInc" onClick={(e) => { GAEventTrackerFacebook('Footer', 1) }}><FacebookIcon fontSize="large" style={{ color: '#fff', fontSize: '38px' }} /></a>
                                                </div>
                                                <div className="pr-2">
                                                    <a target="_blank" href="https://www.instagram.com/calqueinc/" onClick={(e) => { GAEventTrackerInstagram('Footer', 1) }}><InstagramIcon fontSize="large" style={{ color: '#fff', fontSize: '38px' }} /></a>
                                                </div>
                                                <div className="px-1">
                                                    <a target="_blank" onClick={(e) => { GAEventTrackerYouTube('Footer', 1) }} href="https://www.youtube.com/channel/UCqR9EOg_H3vMuTb1lEmNjlg"><YouTubeIcon fontSize="large" style={{ color: '#fff', fontSize: '38px' }} /></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-center d-md-none d-block text-white">
                                            <span>Have more questions?</span><br />
                                            <span><a className="mailto" href={`mailto:${props.emailGlobal ? props.emailGlobal.application_config_value : 'info@calqueinc.com'}`} style={{ cursor: 'pointer', color: 'white' }}>Send an email to: {props.emailGlobal && props.emailGlobal != 0 ? props.emailGlobal.application_config_value : 'info@calqueinc.com'}</a></span>
                                            <div className="d-flex align-items-center justify-content-center pt-2">
                                                <div className="px-1">
                                                    <a target="_blank" href="https://www.linkedin.com/company/calqueinc/" onClick={(e) => { GAEventTrackerFooterLinkedIn('Footer', 1) }}><LinkedInIcon fontSize="large" style={{ color: '#fff', fontSize: '38px' }} /></a>
                                                </div>
                                                <div className="px-1">
                                                    <a target="_blank" href="https://www.facebook.com/CalqueInc" onClick={(e) => { GAEventTrackerFacebook('Footer', 1) }}><FacebookIcon fontSize="large" style={{ color: '#fff', fontSize: '38px' }} /></a>
                                                </div>
                                                <div className="px-1">
                                                    <a target="_blank" href="https://www.instagram.com/calqueinc/" onClick={(e) => { GAEventTrackerInstagram('Footer', 1) }}><InstagramIcon fontSize="large" style={{ color: '#fff', fontSize: '38px' }} /></a>
                                                </div>
                                                <div className="px-1">
                                                    <a target="_blank" onClick={(e) => { GAEventTrackerYouTube('Footer', 1) }} href="https://www.youtube.com/channel/UCqR9EOg_H3vMuTb1lEmNjlg"><YouTubeIcon fontSize="large" style={{ color: '#fff', fontSize: '38px' }} /></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-none d-md-block col-md-4">
                                            {(props.partner.partnership_logo_url || props?.partner?.partner_licence_text || props?.partner?.partner_address) ?
                                                <div className='d-flex justify-content-center align-items-center'>
                                                    {props.partner.partnership_logo_url != null ?
                                                        <img src={`${config.mainUrl}${props?.partner?.logo}`} height="70" width="70" />
                                                        : ''}
                                                    <div className='d-block' style={{ marginLeft: '1vh' }}>
                                                        <p style={{ color: '#fff', fontSize: '1rem', marginBottom: '0.1rem' }} dangerouslySetInnerHTML={{ __html: props?.partner?.partner_licence_text }} />
                                                        <p style={{ color: '#fff', fontSize: '1rem', marginBottom: '0.1rem' }} dangerouslySetInnerHTML={{ __html: props?.partner?.partner_address }} />
                                                        <p style={{ color: '#fff', fontSize: '1rem', marginBottom: '0.1rem' }} dangerouslySetInnerHTML={{ __html: props?.partner?.partner_caution }} />
                                                    </div>
                                                </div> : ''}
                                        </div>
                                        <div className="d-block d-md-none">
                                            {(props.partner.partnership_logo_url || props?.partner?.partner_licence_text || props?.partner?.partner_address) ?
                                                <div className="d-block align-items-center justify-content-center">
                                                    <div className='text-center py-3 pt-4'>
                                                        {props.partner.partnership_logo_url != null ?
                                                            <img src={`${config.mainUrl}${props?.partner?.logo}`} height="60" width="60" />
                                                            : ''}
                                                    </div>
                                                    <div className="d-block">
                                                        <p style={{ color: '#fff', fontSize: '1rem', textAlign: 'center', marginBottom: '0.1rem' }} dangerouslySetInnerHTML={{ __html: props?.partner?.partner_licence_text }} />
                                                        <p style={{ color: '#fff', fontSize: '1rem', textAlign: 'center', marginBottom: '0.1rem' }} dangerouslySetInnerHTML={{ __html: props?.partner?.partner_address }} />
                                                        <p style={{ color: '#fff', fontSize: '1rem', textAlign: 'center', marginBottom: '1rem' }} dangerouslySetInnerHTML={{ __html: props?.partner?.partner_caution }} />
                                                    </div>
                                                </div>
                                                : ''}
                                        </div>
                                        <div className="d-none d-md-block text-md-left text-sm-center text-center pt-md-0 text-white col-md-4">
                                            <a target="_blank" href={props.partner.calque_terms_of_use} style={{ color: 'white' }} onClick={(e) => { GAEventTrackerTermsOfUse('Footer', 1) }}>Calque Terms Of Use</a>
                                            <span className="px-3" style={{ color: 'white' }}>|</span>
                                            <a target="_blank" href={props.partner.calque_privacy_policy} style={{ color: 'white' }} onClick={(e) => { GAEventTrackerPrivacyPolicy('Footer', 1) }}>Calque Privacy Policy</a>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-center d-md-none d-block text-md-right text-sm-center text-center pt-4 pt-md-0 text-white">
                                            <p><a target="_blank" rel="noreferrer" href={props.partner.calque_terms_of_use} style={{ color: 'white' }} onClick={(e) => { GAEventTrackerTermsOfUse('Footer', 1) }}>Calque Terms Of Use</a></p>
                                            <p><span className="px-3" style={{ color: 'white' }}>|</span></p>
                                            <p><a target="_blank" rel="noreferrer" href={props.partner.calque_terms_of_use} style={{ color: 'white' }} onClick={(e) => { GAEventTrackerPrivacyPolicy('Footer', 1) }}>Calque Privacy Policy</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Snackbar open={openSnackbar}
                    autoHideDuration={6000}
                    onClose={handleClose1}
                    anchorOrigin={{ vertical, horizontal }} >
                    <Alert onClose={handleClose1} severity={severity_type}>
                        <div className="error" style={{ color: 'white' }}>
                            <span>{detail}</span>
                        </div>
                    </Alert>
                </Snackbar>
                <Modalpopup open={openSubmit} handleClickOpen={handleClickOpen2} contact={Contactus()} />
                <Modalpopup open={openSuccess} handleClickOpen={handleCloseSuccess} contact={SendOffer()} />
                <Modalpopup open={openFailure} handleClickOpen={handleCloseFailure} contact={Sendfailure()} />
                <Modalpopupcalquemarket open={openCalque} handleClickOpener={handleClickOpener} contactData={calqueMarket()} />
                {cdrawer === false &&
                    <CustomDrawer {...props}
                        cdrawer={cdrawerHome}
                        formik={formik}
                        location={cdrawerHome}
                        handleNext={handleNext}
                        progress={progress}
                        handleChange={formik.handleChange}
                        values={formik.values}
                        errors={formik.errors}
                        validate={formik.validate}
                        drawerClose={drawerClose}
                        drawerHandleClose={drawerHandleClose}
                        getEstimateButton={getEstimateButton}
                        ValidateFinalError={ValidateFinalError}
                        validateDisplay={validateDisplay}
                        validateDisplay0={validateDisplay0}
                        validateDisplay1={validateDisplay1}
                        validateDisplay2={validateDisplay2}
                        validateDisplay3={validateDisplay3}
                        validateDisplay4={validateDisplay4}
                        validateDisplay5={validateDisplay5}
                        validateDisplay6={validateDisplay6}
                        validateDisplay7={validateDisplay7}
                        validateDisplay10={validateDisplay10}
                        validateDisplay11={validateDisplay11}
                        setValidateDisplay6={setValidateDisplay6}
                        setValidateDisplay7={setValidateDisplay7}
                        validateDisplay8={validateDisplay8}
                        setValidateDisplay8={setValidateDisplay8}
                        validateDisplay9={validateDisplay9}
                        setValidateDisplay9={setValidateDisplay9}
                        validateDisplay16={validateDisplay16}
                        validateDisplay17={validateDisplay17}
                        validateDisplay18={validateDisplay18}
                        loader={loader}
                        pageNumber={pageNumber}
                        setPageNumber={setPageNumber}
                        showNxtButton={showNxtButton}
                        setShowNxtButton={setShowNxtButton}
                        captch_visible={captch_visible}
                        setCaptchaVisible={setCaptchaVisible}
                        errorMessage={errorMessage}
                        isSelectedLo={isSelectedLo}
                        setIsSelectedLo={setIsSelectedLo}
                        isSelectedAgent={isSelectedAgent}
                        setIsSelectedAgent={setIsSelectedAgent}
                        setErrorMessage={setErrorMessage}
                        loaderNext={loaderNext}
                        setLoaderNext={setLoaderNext}
                        handleBlur={formik.handleBlur}
                        propertyID={propertyID}
                        setPropertyID={setPropertyID}
                        handleReset={handleReset}
                        resetPadding={resetPadding}
                        emailError={emailError}
                        setEmailError={setEmailError}
                        emailEdit={emailEdit}
                        setEmailEdit={setEmailEdit}
                        emailValue={emailValue}
                        setEmailValue={setEmailValue}
                        setEmailEditErr={setEmailEditErr}
                        emailEditErr={emailEditErr}
                        emailOneDisable={emailOneDisable}
                        setEmailOneDisable={setEmailOneDisable}
                        old_address={old_address}
                        old_property_type_id={old_property_type_id}
                        handleProgress={handleProgress}
                        setSubmitSuccess={setSubmitSuccess}
                        submitSuccess={submitSuccess}
                        setDisplayError={setDisplayError}
                        displayError={displayError}
                        partner={props.partner}
                        GAtimer={props.GAtimer}
                        GAtimerFinish={props.GAtimerFinish}
                        gaUserNotAnswered={gaUserNotAnswered}
                        setGaUserNotAnswered={setGaUserNotAnswered}
                        partnerContactRole={props.partnerContactRole}
                        condition={props.condition}
                        aboutUsList={props.aboutUsList}
                        conditionList={props.conditionList} 
                        defectsList={props.defectsList}
                        setCaptchaValue={setCaptchaValue}
                        captchaValue={captchaValue}
                    />
                }
            </form>
        </div>
    )
}